
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Service Area', href: '/service-area' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
                <i className="ri-file-text-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold text-gray-900">GCM MOBILE NOTARY</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              Home
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              About
            </Link>
            <Link to="/services" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              Services
            </Link>
            <Link to="/service-area" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              Service Area
            </Link>
            <Link to="/blog" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              Blog
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
              Contact
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a
              href="tel:+18772113011"
              className="bg-gray-900 text-white px-6 py-2 rounded-lg font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Call Now
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-7

70 hover:text-orange-500 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              <Link to="/" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                Home
              </Link>
              <Link to="/about" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                About
              </Link>
              <Link to="/services" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                Services
              </Link>
              <Link to="/service-area" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                Service Area
              </Link>
              <Link to="/blog" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                Blog
              </Link>
              <Link to="/contact" className="block px-3 py-2 text-gray-700 hover:text-orange-500 transition-colors cursor-pointer">
                Contact
              </Link>
              <a
                href="tel:+18772113011"
                className="block w-full text-center bg-gray-900 text-white px-6 py-2 rounded-lg font-medium hover:bg-gray-800 transition-colors mt-4 cursor-pointer"
              >
                Call Now
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
